import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import {
  applyEvent,
  CommonOrCommonRetirementFlug,
} from "../../assets/data/Constants";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkButton from "../../components/atoms/TkButton";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkMemo from "../../components/molecules/TkMemo";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import { httpAPI_APP016, httpAPI_CON021, httpAPI_CON022 } from "./api/request";
import { fakeTableList, headList, schema } from "./parts";
import "./_style.scss";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import { IAPI_APP016_Request } from "../../type/apiType";
import _ from "lodash";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import { isStatusAfterApproval } from "../../utils/useTools";
import { TkRouteContext } from "../../context/tkRouteContext";
import { TkGetCode } from "../../utils/TkGetCode";
import TkDialog from "../../components/atoms/TkDialog";

/**
 * SCRW070007 契約解除（共済法令違反）内容入力
 * 機構職員が契約解除（共済法令違反）の内容を入力する。
 * @return SCRW070007
 */
const SCRW070007 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const applyId = location.state?.applyId;
  const ref = useRef<{ submit: (temSave?: boolean) => void } | null>(null);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [memoBodyList, setMemoBodyList] = useState<any>([]);
  const [bodyList, setBodyList] = useState<any>([]);
  const [status, setStatus] = useState<ITkViewButtonJudgementStatus>();
  const { state: stateRouter } = useContext(TkRouteContext);
  const [cancelDate, setCancelDate] = useState("");
  const [violationDetail, setViolationDetail] = useState("");
  const [memo, setMemo] = useState("");
  const [check, setCheck] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const httpReqIApplicationStatusUpdateRequest: any = {};
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [openApply, setOpenApply] = useState(false);

  // 初期表示
  const handleCallApiInit = async () => {
    // 契約解除（共済法令違反）内容表示API実行
    try {
      const res = await httpAPI_CON022({
        applyId,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;

        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;

          if (targetObj) {
            targetObj.setDefaultValue = res[i as keyof typeof res];
            targetObj.disabled = true;
          }
        }

        setStateTableList([...resArr]);

        // メモ欄
        let bodyList = res.statusList?.map((item: any) => [
          {
            children: item.managerName,
          },
          {
            children: item.process,
          },
          {
            children: item.createDate,
          },
          {
            children: item.processComment,
          },
        ]);
        setMemoBodyList(bodyList);

        // 決裁日・記号番号
        let bodyListApproval = [
          [{ children: res.approvalDate }, { children: res.symbolNo }],
        ];
        setBodyList(bodyListApproval);

        setStatus(res.latestApplyStatus as ITkViewButtonJudgementStatus);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    contractorName.contractorNumber = `${businessState.common?.contractorNo}:${businessState.common?.contractorName}`;
    setStateTableList([...resArr]);

    if (applyId) {
      handleCallApiInit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let resArr = [...stateFakeTableList.current];
    let cancelDate = resArr.find((item) => item.keyword === "cancelDate")!;
    let lawsViolationDetail = resArr.find(
      (item) => item.keyword === "lawsViolationDetail"
    )!;

    cancelDate.onGetInputValue = (e: any) => {
      setCancelDate(e.target.value);
    };

    lawsViolationDetail.onGetValue = (e: any) => {
      setViolationDetail(e);
    };

    setStateTableList([...resArr]);
  }, [state]);

  const handleMemoChange = (e: any) => {
    if (e.target.type === "input") {
      setMemo(e.target.value);
    } else {
      setCheck(e.target.value ? "1" : "");
    }
  };

  const handleCallApiRegister = async () => {
    // 契約解除（共済法令違反）内容更新
    try {
      const res = await httpAPI_CON021({
        applyId: businessState.job_09?.applyId,
        contractorNo: businessState.common?.contractorNo,
        cancelDate: cancelDate,
        lawsViolationDetail: violationDetail,
        screenId: "SCRW070007",
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110003");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleCallApiFlow = async (applyEvent: any) => {
    // 申請状況更新API実行
    let reqData: IAPI_APP016_Request = makeHttpObj(
      applyEvent,
      httpReqIApplicationStatusUpdateRequest
    );
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSubmit = async (
    type: "register" | "flow",
    event?: keyof typeof applyEvent
  ) => {
    switch (type) {
      case "register":
        setOpenApply(true);
        break;

      case "flow":
        if (applyEvent[event!] === "3") {
          setIsOpen(true);
          return;
        }
        handleCallApiFlow(applyEvent[event!]);
        break;
    }
  };

  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj("3", formData);
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const setOpen = () => {
    setIsOpen(false);
  };

  // データを作成
  const makeHttpObj = (num: string, formData?: any): IAPI_APP016_Request => {
    const req: IAPI_APP016_Request = {
      applyId,
      applyEvent: num,
      contractorNo: businessState.common?.contractorNo,
      screenId: "SCRW070007",
      inquiryCode: check,
      reason: memo,
    };

    if (formData?.symbolNumber) {
      req.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";

      req.decisionDate = formData.settlementDate;
    }

    return req;
  };

  return (
    <Box className="SCRW070007" data-testid="SCRW070007">
      {applyId && (
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType="JOB_09"
          applicationStatus={status}
        />
      )}

      <TkFakeTable
        ref={ref}
        list={stateTableList}
        ruleSchema={schema}
        showButton={false}
      />

      <TkMemo bodyList={memoBodyList} onChange={handleMemoChange} />

      {isStatusAfterApproval(status) && (
        <TkTableWithNoLine headList={headList} bodyList={bodyList} />
      )}

      <Box className="button">
        <TkBackButton mr />
        {stateRouter.routerList?.find(
          (item) => item?.href === "/SCRW110003"
        ) && (
          <TkButton onClick={() => handleSubmit("register")} mr>
            申請
          </TkButton>
        )}
        {applyId && (
          <TkViewButtonJudgement
            Status={status}
            flowType="TYPE2"
            onClick={(e: any) => handleSubmit("flow", e)}
          />
        )}
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        open={isOpen}
        onSuccess={handleSave}
        onClose={setOpen}
        isScheduledPaymentDateVisible={false}
      />

      <TkDialog
        title="確認（情報を登録します）"
        contextText="　入力した内容で登録を行いますが、問題ないでしょうか。"
        open={openApply}
        okText="はい"
        cancelText="いいえ"
        onSave={() => handleCallApiRegister()}
        onCancel={() => setOpenApply(false)}
      />
    </Box>
  );
};

export default SCRW070007;
